import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../../components/LanguageSwitcher';

// import LanguageSwitcher from './../../../components/LanguageSwitcher'
const LoginForm = ({
  email,
  setEmail,
  password,
  setPassword,
  handleSubmit,
  errors,
  loading,
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };
  const [openLangChange, setOpenLangChange] = useState(false);
  const handleLangeChangeClick = () => {
    setOpenLangChange(!openLangChange);
  };

  const handleOutsideClick = (e) => {
    if (!e.target.closest('.change-language')) {
      setOpenLangChange(false);
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);
  return (
    <form onSubmit={handleSubmit}>
      <div className="change-language">
        {/* <button type="button" className="language">
          <img className="eng" src="images/language.svg" alt="" />
        </button>
        <div className="language-change">
          <ul>
            <li>
              <div className="">
                <img src="images/language1.svg" className="pe-1" />
                English
              </div>
              <img src="images/checkimg.svg" alt="" />
            </li>
            <li>
              <div className="">
                <img src="images/language2.svg" className="pe-1" />
                繁體中文
              </div>
              <img src="images/checkimg.svg" alt="" />
            </li>
          </ul>
        </div> */}

        <LanguageSwitcher
          handleLangeChangeClick={handleLangeChangeClick}
          openLangChange={openLangChange}
          color="white"
        />
      </div>
      <h1>{t('LOGIN')}</h1>
      <div className="did-floating-label-content mb-4">
        <input
          className="did-floating-input"
          type="email"
          name="email"
          id="email"
          placeholder=" "
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <label className="did-floating-label">{t('EMAILADDRESS')}</label>
        {errors.email && (
          <div className="mt-2 text-danger">{errors.email[0]}</div>
        )}
      </div>

      <div className="did-floating-label-content">
        <input
          className="did-floating-input"
          type={showPassword ? 'text' : 'password'}
          name="password"
          id="password"
          placeholder=" "
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />

        <span className="eye-icon" onClick={togglePasswordVisibility}>
          <img
            src={showPassword ? 'images/eye-change.svg' : 'images/eye.svg'}
            alt={showPassword ? 'Hide Password' : 'Show Password'}
          />
        </span>
        <label className="did-floating-label">{t('PASSWORD')}</label>
        {errors.password && (
          <div className="mt-2 text-danger">{errors.password[0]}</div>
        )}
      </div>

      <div className="custom-container">
        <label className="remember">
          <input type="checkbox" />
          <span className="checkbox-custom"></span>
          {t('REMEMBERME')}
        </label>
        <a href="/forgot-password" className="forget-password">
          {t('FORGOTPASSWORD')}?
        </a>
      </div>

      {errors.general && (
        <div className="mt-2 text-danger">{errors.general}</div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="login btn btn-primary"
      >
        {t('LOGIN')}
      </button>
    </form>
  );
};

export default LoginForm;
